export default __webpack_public_path__ + "static/media/logo.d5f5c88f.webp";